import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../../contexts/authContext';
import { contractsClient } from './api';
import { contractQueryKey } from './ContractsTab';
import { identityLabel } from './facts';
/**
 * Says whether a typed PIID / contract number already exists as a registry contract, so a
 * typed identifier is checked against the registry instead of trusted blindly.
 */ export function PiidMatchHint({ piid, excludeId }) {
    const term = piid.trim();
    const { user } = useAuth();
    // Keyed by tenant and viewer like every other contract read: private contracts differ by
    // viewer, so no cached answer may cross identities.
    const viewer = {
        tenant: user?.tenant_id ?? '',
        user: user?.id ?? ''
    };
    const q = useQuery({
        queryKey: contractQueryKey(viewer, 'piid-match', term),
        queryFn: ()=>contractsClient.browseRegistryContracts({
                piid: term,
                afterId: '',
                limit: 5
            }),
        enabled: term.length >= 4 && !!viewer.tenant && !!viewer.user,
        retry: false,
        staleTime: 30000
    });
    if (term.length < 4 || q.isPending || q.isError) return null;
    const matches = (q.data?.contracts ?? []).filter((c)=>c.id !== excludeId && c.identity?.piid?.toUpperCase() === term.toUpperCase());
    return /*#__PURE__*/ _jsx(SpecraText, {
        as: "p",
        size: "caption",
        tone: matches.length ? 'info' : 'muted',
        "data-testid": Testids.registryContracts.piidMatch,
        children: matches.length ? `Already in the registry: ${matches.map((c)=>identityLabel(c.identity)).join('; ')}` : 'No registry contract has this number yet.'
    });
}
